import { render, staticRenderFns } from "./NK025V2021.vue?vue&type=template&id=1274b155&"
import script from "./NK025V2021.vue?vue&type=script&lang=js&"
export * from "./NK025V2021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports